import { buildParams, http } from "./http"

export const getMyOrders = (params: any) => 
  http.get<any, any>(`/loyalty/orders${buildParams(params)}`)

export const getList = (params: any) => 
  http.get<any, any>(`/loyalty/orders/list/${buildParams(params)}`)

export const getOrderById = (id: number) => 
  http.get<any, any>(`/loyalty/orders/list/${id}`)

export const createOrder = (dto: any) => 
  http.post<any, any>(`/loyalty/orders/list/`, dto)

export const updateOrder = (id: number, dto: any) => 
  http.put<any, any>(`/loyalty/orders/list/${id}`, dto)

export const deleteOrder = (id: number) => 
  http.delete<any, any>(`/loyalty/orders/list/${id}`)

export const createPayment = (dto: any) => 
  http.post<any, any>(`/loyalty/orders/payment`, dto)

export const checkPayment = (id: number) => 
  http.get<any, any>(`/loyalty/orders/payment/status/${id}`)
